var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-btn',{staticClass:"ma-2",attrs:{"color":_vm.color}},[_vm._v(_vm._s(_vm.missing))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }